import * as React from "react";
import {
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import {
    AdvancedSavedSearchItem,
    KeyValue
} from "../../../services/types/enterpriseCoachingApiTypes";
import AdvancedSearchSingleSelect from "../../resources/cclResources/advancedSearchSingleSelect";
import { useGetAdvancedSearchOptionsQuery } from "../../../services/cclTokenedEnterpriseParticipantApi";

interface RegistrationSearchCardProps {
    updateCurrentSearch: (search: any) => void;
    pastSearch: AdvancedSavedSearchItem;
}

export interface AttributeSearch {
    attributeType: AutocompleteItem | undefined;
    attributeValue: AutocompleteItem | undefined;
    attributeLevel: AutocompleteItem | undefined;
    id: string;
}

export interface AutocompleteItem {
    id: string;
    label: string;
}

const RegistrationSearchCard: React.FC<RegistrationSearchCardProps> = (props) => {

    const [firstName, setFirstName] = React.useState<string>(props.pastSearch?.registration?.firstName ? props.pastSearch.registration.firstName.label : "");
    const [lastName, setLastName] = React.useState<string>(props.pastSearch?.registration?.lastName ? props.pastSearch.registration.lastName.label : "");
    const [email, setEmail] = React.useState<string>(props.pastSearch?.registration?.email ? props.pastSearch.registration.email.label : "");
    const {data: advancedSearchOptions} = useGetAdvancedSearchOptionsQuery();
    const statusOptions = advancedSearchOptions ? advancedSearchOptions.registrationStatusTypes.map((st:any) => ({id: st.val, label: st.option})) : [];

    const handleStatusChange = (status: any) => {
        let temp = props.pastSearch;
        if (temp) {
            temp.registration.participantStatus = mapIdToLabel(status, statusOptions)[0];
            props.updateCurrentSearch(temp);
        }
    }

    const handleFirstNameChange = (firstName: string) => {
        setFirstName(firstName);
        let temp = props.pastSearch;
        temp.registration.firstName = { id: firstName, label: firstName };
        props.updateCurrentSearch(temp);
    }

    const handleLastNameChange = (lastName: string) => {
        setLastName(lastName);
        let temp = props.pastSearch;
        temp.registration.lastName = { id: lastName, label: lastName };
        props.updateCurrentSearch(temp);
    }

    const handleEmailChange = (email: string) => {
        setEmail(email);
        let temp = props.pastSearch;
        temp.registration.email = { id: email, label: email };
        props.updateCurrentSearch(temp);
    }

    const mapIdToLabel = (id: number[] | string[], map: KeyValue[]) => {
        let values: KeyValue[] = [];
        for (let i = 0; i < id.length; i++) {
            //eslint-disable-next-line
            let label = map.find((x) => x.id == id[i]);
            if (label) {
                values.push(label);
            }
        }
        return values;
    };

    return (
        <Stack sx={{ m: 1, mt: 2 }} spacing={4}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Participant
            </Typography>
            <AdvancedSearchSingleSelect
                dataList={statusOptions}
                id="status"
                label="Status"
                handleSelectionChanged={handleStatusChange}
                defaultValue={
                    props.pastSearch?.registration?.participantStatus ? props.pastSearch.registration.participantStatus : null
                }
            />
            <TextField
                size="small"
                id="first-name"
                label="First Name"
                variant="outlined"
                onChange ={(e)=> {handleFirstNameChange(e.target.value)}}
                fullWidth
                value={firstName}
            />
            <TextField
                size="small"
                id="last-name"
                label="Last Name"
                variant="outlined"
                onChange ={(e)=> {handleLastNameChange(e.target.value)}}
                fullWidth
                value={lastName}
            />
            <TextField
                size="small"
                id="email"
                label="Email"
                variant="outlined"
                onChange ={(e)=> {handleEmailChange(e.target.value)}}
                fullWidth
                value={email}
            />
        </Stack>
    );
};

export default RegistrationSearchCard;